<script setup lang="ts">
// A hairline rule between menu groups (Reka DropdownMenuSeparator - aria
// role="separator", skipped by keyboard nav).
import { DropdownMenuSeparator } from 'reka-ui';
</script>

<template>
  <DropdownMenuSeparator class="hq-menu__sep" />
</template>

<!-- Unscoped: portalled to <body> by Reka (scoped hashes don't reach it). -->
<style>
.hq-menu__sep {
  height: 1px;
  border: 0;
  background: var(--border-subtle);
  margin: var(--space-1) calc(-1 * var(--space-2));
}
</style>
